module.exports = __webpack_public_path__ + "8d79bc440802ff757a6d01cbc3fe9a4a.pdf";